import React from "react";
import {Flex, Loader} from "@aws-amplify/ui-react";

const Loading = () => (
  <Flex
    height="calc(100vh - 180px)"
    width="100%"
    textAlign="center"
    alignItems="center"
    justifyContent="center"
    padding="32px"
  >
    <Loader
      size="large"
      style={{
        width: "100px",
        height: "100px",
      }}
      filledColor="#9381ff"
      emptyColor="#f8f7ff"
    />
  </Flex>
);

export default Loading;